import { render, staticRenderFns } from "./TableCellTypeTextarea.vue?vue&type=template&id=ecf52f98&scoped=true"
import script from "./TableCellTypeTextarea.vue?vue&type=script&lang=js"
export * from "./TableCellTypeTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf52f98",
  null
  
)

export default component.exports